import { message } from 'antd';
import { call, put, all, takeLatest } from 'redux-saga/effects'
import { FETCH_VISITS_REPORT, FETCH_VISITS_REPORT_START, FETCH_VISITS_REPORT_SUCCESS, FETCH_VISITS_REPORT_ERROR,FETCH_PAYMENTS_REPORT, FETCH_PAYMENTS_REPORT_START, FETCH_PAYMENTS_REPORT_SUCCESS, FETCH_PAYMENTS_REPORT_ERROR, SET_VISITS_REPORT_PAGINATION, SET_PAYMENTS_REPORT_PAGINATION } from "../../actions/admin/visitsReportAction";
import { fetchVisitsReportAPI, fetchPaymentsReportAPI } from '../../../services/report-services';
import _ from 'lodash';

function* fetchVisitsReport({ payload }) {
    try {
        yield put({ type: FETCH_VISITS_REPORT_START })
        const response = yield call(fetchVisitsReportAPI, payload);
        if (response.success) {

            let pagination = {
                currentPage: payload.filterRequest.page,
                pageSize: payload.filterRequest.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }

            yield put({ type: SET_VISITS_REPORT_PAGINATION, pagination })
            yield put({ type: FETCH_VISITS_REPORT_SUCCESS, visitsReport: _.cloneDeep(response.data.visitReport) })
        } else {
            yield put({ type: FETCH_VISITS_REPORT_ERROR, error: response.error })
            message.error('Failed to fetch report!');
        }
    } catch (error) {
        yield put({ type: FETCH_VISITS_REPORT_ERROR, error })
        message.error('Failed to fetch report!');
    }
}

function* fetchPaymentsReport({ payload }) {
    try {
        yield put({ type: FETCH_VISITS_REPORT_START })
        const response = yield call(fetchPaymentsReportAPI, payload);
        if (response.success) {

            let pagination = {
                currentPage: payload.filterRequest.page,
                pageSize: payload.filterRequest.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }

            yield put({ type: SET_PAYMENTS_REPORT_PAGINATION, pagination })
            yield put({ type: FETCH_PAYMENTS_REPORT_SUCCESS, visitsReport: _.cloneDeep(response.data.paymentReport) })
        } else {
            yield put({ type: FETCH_PAYMENTS_REPORT_ERROR, error: response.error })
            message.error('Failed to fetch report!');
        }
    } catch (error) {
        yield put({ type: FETCH_PAYMENTS_REPORT_ERROR, error })
        message.error('Failed to fetch report!');
    }
}

function* visitsReportWatcher() {
    yield takeLatest(FETCH_VISITS_REPORT, fetchVisitsReport)
    yield takeLatest(FETCH_PAYMENTS_REPORT, fetchPaymentsReport)
}

export default function* rootSaga() {
    yield all([
        visitsReportWatcher(),
    ]);
}